enum Examination {
    APPROVED = 'Goedgekeurd',
    REINSPECTION = 'Herkeuring',
    REJECTED = 'Afgekeurd',
}; // eslint-disable-line

export default Examination;
